import { render, staticRenderFns } from "./InjuriesCard.vue?vue&type=template&id=394d35ac&scoped=true"
import script from "./InjuriesCard.vue?vue&type=script&lang=js"
export * from "./InjuriesCard.vue?vue&type=script&lang=js"
import style0 from "./InjuriesCard.vue?vue&type=style&index=0&id=394d35ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394d35ac",
  null
  
)

export default component.exports